import {useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from "../../redux/modules/auth"
import { getMeetingsList, getBrokerToursList } from "../../redux/modules/meeting";
import useIdle from '../../hooks/useIdle';
import moment from 'moment';

const links = {
  '/': 'Дашборд',
  '/check-client': 'Проверить клиента',
  '/docs': 'Документы',
  '/contacts': 'Контакты',
  '/regist-meeting': 'Записаться на встречу',
  '/regist-broker-tour': 'Записаться на брокер-тур',
  '/agents-list': 'Пользователи',
  '/add-blacklist': 'Пользователи',
  '/delete-blacklist': 'Пользователи',
  '/change-access': 'Пользователи',
  '/delete-agent': 'Пользователи',
  '/news':"Новости",
  '/profile':"Профиль пользователя",
  '/clients':"Клиенты",
  '/meetings':"Встречи",
  '/bookings':"Брони",
  '/deals':"Сделки",
  '/broker-tours':"Брокер-туры",
  '/edit-meeting':"Встречи",
  '/edit-broker-tour':"Брокер-туры", 
  '/cancel-meeting':"Отменить встречу", 
  '/cancel-broker-tour':"Отменить брокер-тур", 
};
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];


const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const mobile = useSelector(state => state.mobile);
  const meetings = useSelector(state => state.meeting.response);
  const brokertours = useSelector(state => state.meeting.brokertours);
  const [menu, setMenu] = useState(false);
  const [usermenu, setUserMenu] = useState(false);
  const location = useLocation();
  const timerRef = useRef(null);


  const logout = () => {
    dispatch(
      signOut({
        cmd: 'authorization-logout',
        _debug_token: auth.token
      })
    );
  };

  const { getLastActiveTime, isIdle } = useIdle({onIdle:logout,idleTime:30})

  //console.log(isIdle)
  /*const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const handleLogoutTimer = () => {
    resetTimer();
    timerRef.current = setTimeout(() => {
      resetTimer();
      events.forEach((event) => window.removeEventListener(event, resetAndStartTimer));
      logout();
    }, 1800000); // 30 минут
  };

  const resetAndStartTimer = () => {
    resetTimer();
    handleLogoutTimer();
  };*/

  const scrolled = () => {
    const header = document.querySelector('.page__header');
    const content = document.querySelector('.page__content');
    const scrollTop = document.querySelector('.page__content').scrollTop;
    
    if (scrollTop >= 30) {
      setUserMenu(false);
      header.classList.add('scroll');
      content.classList.add('scroll');
    } else {
      header.classList.remove('scroll');
      content.classList.remove('scroll');
    }
  };

  useEffect(() => {
    //alert('localStorage: ' + localStorage.getItem('user') + ' user: ' + JSON.stringify(auth.user));
    //events.forEach((event) => window.addEventListener(event, resetAndStartTimer));
    document.querySelector('.page__content').addEventListener('scroll', scrolled);
    //handleLogoutTimer();

    let diff = moment() - moment(localStorage.getItem("lastEvent"));
    let rest = 30 * 60 * 1000 - diff;
    let minutes = Math.round(rest / 1000 / 60);

    //console.log('minutes', minutes);

    if(minutes <= 0) {
      logout();
    }

    if(!meetings) {
      dispatch(
        getMeetingsList({
          cmd: 'orders-list',
          eventTypeId: 1,
          _debug_token: auth.token
        })
      )
    }
    if(!brokertours) {
      dispatch(
        getBrokerToursList({
          cmd: 'orders-list',
          eventTypeId: 2,
          _debug_token: auth.token
        })
      )
    }

    return () => {
      //events.forEach((event) => window.removeEventListener(event, resetAndStartTimer));
      //document.querySelector('.page__content').removeEventListener('scroll', scrolled);
      //resetTimer();
    };
  }, []);

  if(!auth) return null;

  const menuOpen = () => {
    if(mobile) setMenu(!menu)
  }

  const userMenuOpen = () => {
    setUserMenu(!usermenu)
  }

  return (
    <div className="page">
      <div className="page__header">
        <div className="page__header__wrap">
          <div className="page__logo"></div>
          <div className={usermenu ? "user-info user-info_open" : "user-info"}>
            <div className="user-info__name" onClick={userMenuOpen}>{auth.user.fio}</div>
            <div className="user-menu">
              {!mobile && <div className="user-menu__close" onClick={userMenuOpen}></div>}
              <div className="user-menu__item">
                <Link to="/profile">Профиль</Link>
              </div>{/**/}
              <div className="user-menu__item">
                <a onClick={logout}>Выйти</a>
              </div>
            </div>
          </div>
        </div>
        {mobile && (<div className="page__header__title">
          <div className="page__title">{links[location.pathname.indexOf('/docs') == 0 ? '/docs' : (location.pathname.indexOf('/news') == 0 ? '/news' : location.pathname)]}</div>
          <div className="menu-icon" onClick={menuOpen}><div></div><div></div><div></div></div>
        </div>)}
      </div>
      <div className="page__container">
        <div className={mobile && menu ? "page__sidebar page__sidebar_open" : "page__sidebar"}>
          <div className="menu">
            {mobile && <div className="menu-close" onClick={menuOpen}></div>}
            {mobile && <div className="menu__separator"></div>}
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/" className={({isActive}) => (isActive ? "active" : '')}>Дашборд</NavLink>
            </div>
            {/*<div className={meetings && meetings.filter(el => el.status === 'Выполнена' && el.rate == undefined).length ? "menu__item menu__item_withbell" : "menu__item"} onClick={()=>{menuOpen()}}>
              <NavLink to="/meetings" className={({isActive}) => (isActive ? "active" : '')}>Встречи</NavLink>
            </div>
            <div className={brokertours && brokertours.filter(el => el.status === 'Выполнена' && el.rate == undefined).length ? "menu__item menu__item_withbell" : "menu__item"}>
              <NavLink to="/broker-tours" className={({isActive}) => (isActive ? "active" : '')}>Брокер-туры</NavLink>
            </div>*/}
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/meetings" className={({isActive}) => (isActive ? "active" : '')}>Встречи</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/broker-tours" className={({isActive}) => (isActive ? "active" : '')}>Брокер-туры</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/clients" className={({isActive}) => (isActive ? "active" : '')}>Клиенты</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/bookings" className={({isActive}) => (isActive ? "active" : '')}>Брони</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/deals" className={({isActive}) => (isActive ? "active" : '')}>Сделки</NavLink>
            </div>
            {/*<div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/realty" className={({isActive}) => (isActive ? "active" : '')}>Выбор недвижимости</NavLink>
            </div>*/}
            {auth.user.group == 'lead' && (
              <div className="menu__item" onClick={()=>{menuOpen()}}>
                <NavLink to="/agents-list" className={({isActive}) => (isActive ? "active" : '')}>Пользователи</NavLink>
              </div>
            )}
            <div className="menu__separator"></div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/check-client" className={({isActive}) => (isActive ? "active" : '')} id="check">Проверить клиента</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/regist-meeting" className={({isActive}) => (isActive ? "active" : '')}>Записаться на встречу</NavLink>
            </div>
            <div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/regist-broker-tour" className={({isActive}) => (isActive ? "active" : '')}>Записаться на&nbsp;брокер-тур</NavLink>
            </div>{/**/}
            {/*<div className="menu__item" onClick={()=>{menuOpen()}}>
              <NavLink to="/choose-realestate" className={({isActive}) => (isActive ? "active" : '')}>Выбрать недвижимость</NavLink>
            </div>*/}
            <div className="menu__separator"></div>
            <div className="menu__item menu__item_mrg" onClick={()=>{menuOpen()}}>
              <NavLink to="/docs" className={({isActive}) => (isActive ? "active" : '')}>Документы</NavLink>
            </div>
            <div className="menu__item menu__item_mrg" onClick={()=>{menuOpen()}}>
              <NavLink to="/contacts" className={({isActive}) => (isActive ? "active" : '')}>Контакты</NavLink>
            </div>
            <div className="menu__item menu__item_mrg" onClick={()=>{menuOpen()}}>
              <NavLink to="/news" className={({isActive}) => (isActive ? "active" : '')}>Новости</NavLink>
            </div>
          </div>

          <div className="links">
            <a href="https://t.me/thefivepartners" target="_blank" className="links__item links__item_tg"></a>
            <a href="tel:+74999578901" className="links__item links__item_phone">+7 (499) 957 89 01</a>
          </div>
        </div>
        <div className={mobile && usermenu ? "page__content page__content_open" : "page__content"}>
          {children}
        </div>
        {/*mobile && (<div className="page__footer">
          <div className="links">
            <a href="https://t.me/thefivepartners" target="_blank" className="links__item links__item_tg"></a>
            <a href="tel:+74999578901" className="links__item links__item_phone">+7 (499) 957 89 01</a>
          </div>
        </div>)*/}
      </div>      
    </div>
  )
}

export default Layout